import { httpsCallable } from "firebase/functions"
import { useCallback, useState } from "react"

import { functions } from "../firebase"

interface ConnectLclResult {
  connectionId: string
}

const connectLclFn = httpsCallable<
  { clientId: string; password: string },
  ConnectLclResult
>(functions, "connectLcl")

const confirmLclAccountsFn = httpsCallable<
  { connectionId: string; selectedAccountIds: string[] },
  object
>(functions, "confirmLclAccounts")

const requestLclSyncFn = httpsCallable<
  { connectionId: string; accountId: string },
  object
>(functions, "requestLclSync")

export function useLclConnection() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | undefined>()

  const connect = useCallback(async (clientId: string, password: string) => {
    setLoading(true)
    setError(undefined)
    try {
      const result = await connectLclFn({ clientId, password })
      return result.data.connectionId
    } catch (err) {
      setError(err as Error)
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  const confirm = useCallback(
    async (connectionId: string, selectedAccountIds: string[]) => {
      await confirmLclAccountsFn({ connectionId, selectedAccountIds })
    },
    [],
  )

  const requestSync = useCallback(
    async (connectionId: string, accountId: string) => {
      await requestLclSyncFn({ connectionId, accountId })
    },
    [],
  )

  return { connect, confirm, requestSync, loading, error }
}
